module.exports = __webpack_public_path__ + "img/flyer_07.02a5d557.jpeg";